import React from "react";
import PreviewFormRouter_v2 from "components/common/PreviewFormRouter_v2";
import PreviewFormRouter_vo from "components/common/PreviewFormRouter_vo";
import PreviewFormRouter_cs from "components/common/PreviewFormRouter_cs";
import PreviewFormRouter_cs_1 from "components/common/PreviewFormRouter_cs_1";
import PreviewFormRouter_cp from "components/common/PreviewFormRouter_cp";
import PreviewFormRouter_excs from "components/common/PreviewFormRouter_excs";
import { useLocation, useNavigate } from "react-router-dom";
import { resp_service_filter } from "config/const/global";
import { getKeyByValue } from "utils/getKeyByValue";
import PreviewFormRouter_exrb from "components/common/PreviewFormRouter_exrb";
import { useTranslation } from "react-i18next";
import { KEY_LABEL_FORM_PREVIOUS, MODULE_PREVIEW_ROUTER_FORM } from "config/const/locale";
import { Button } from "@mui/material";

let hkl = getKeyByValue(resp_service_filter.value.value, resp_service_filter.value.value.hongkong) + '.' +
    getKeyByValue(resp_service_filter.value.value.hongkong, resp_service_filter.value.value.hongkong.limited_company)
let virtual_office = getKeyByValue(resp_service_filter.value.value.value_added_service, resp_service_filter.value.value.value_added_service.virtual_office)
let BVI = getKeyByValue(resp_service_filter.value.value, resp_service_filter.value.value.BVI)
let cayman = getKeyByValue(resp_service_filter.value.value, resp_service_filter.value.value.cayman)
let seychelles = getKeyByValue(resp_service_filter.value.value, resp_service_filter.value.value.seychelles)
let company_secretary_company_secretary_services = resp_service_filter.value.value.company_secretary.company_secretary_services
let company_secretary_annual_return_service = resp_service_filter.value.value.company_secretary.annual_return_service
let bank_account_registration = getKeyByValue(resp_service_filter.value.value.value_added_service, resp_service_filter.value.value.value_added_service.bank_account_registration)
let business_name_card = 'business_name_card'
let customized_seal = getKeyByValue(resp_service_filter.value.value.value_added_service, resp_service_filter.value.value.value_added_service.customized_seal)
let tm = getKeyByValue(resp_service_filter.value.value.value_added_service, resp_service_filter.value.value.value_added_service.trademark_registration)

export default function DetailForm() {

    const { t } = useTranslation(MODULE_PREVIEW_ROUTER_FORM)
    const { state } = useLocation()
    const nav = useNavigate()

    const formRenderer = () => {
        const name = state?.user_service?.service?.name

        switch (true) {
            case name?.includes(hkl):
                return <PreviewFormRouter_v2 state={state} />;
            case name?.includes(virtual_office):
                return <PreviewFormRouter_vo state={state} />;
            case name?.includes(company_secretary_company_secretary_services):
                return <PreviewFormRouter_cs state={state} />;
            case name?.includes(company_secretary_annual_return_service):
                return <PreviewFormRouter_cs_1 state={state} />;
            case name?.includes(business_name_card):
                return <PreviewFormRouter_cp state={state} />;
            case name?.includes(customized_seal):
                return <PreviewFormRouter_excs state={state} />;
            case name?.includes(bank_account_registration):
                return <PreviewFormRouter_exrb state={state} />;
            case name?.includes(tm):
                return <PreviewFormRouter_exrb state={state} />;

            default:
                return <PreviewFormRouter_v2 state={state} />;
        }
    }

    return (
        <>
            <Button onClick={() => nav(-1)} variant='contained'>{t(KEY_LABEL_FORM_PREVIOUS)}</Button>
            {formRenderer()}
        </>
    );
}
